<template>
  <!-- 公告 -->
  <div id="notice">
    <div class="bn-title">
      <!-- 系统公告 -->
      <!-- {{$t('indexPage.notice')}} -->
    </div>
    <vue-seamless-scroll
      :data="list"
      :class-option="optionLeft"
      class="seamless-warp2"
    >
      <ul class="item" @click="openDlg()">
        <li
          v-for="(item, index) in list"
          :key="index"
          v-text="item.content"
        ></li>
      </ul>
    </vue-seamless-scroll>
    <img loading="lazy" v-if="platReg === 'amjs'" class="domain" :src="$common.getImgUrl($config.pcYijiUrl)">
    <img loading="lazy" v-if="platReg === 'qxyl'" class="domain" v-lazy="require('../assets/images/amjs/domain_qxyl.gif')">
    <dlg-notice :list="list" ref="dlgnotice"></dlg-notice>
  </div>
</template>

<script>
import dlgNotice from '@/components/dialogNotice'
export default {
  // props:{
  //   list:{
  //     type:Array,
  //     default: function () {
  //         return []
  //       }
  //   }
  // },
  components:{
    dlgNotice
  },
  data() {
    return {
        list:[],
        platReg: ''
    };
  },
  created(){
    this.getNotices();
    this.platReg = window.projectImgUrl;
  },
  methods:{
    openDlg(){
      this.$refs['dlgnotice'].showDialog = true;
    },
    async getNotices() {
      var _this = this
      var data = {
        createdAt: '',
        currentPage: '',
        pageSize: '',
        publishedAt: '',
        subject: '',
        type: ''
      }
      var res = await _this.$http.post(_this.$api.noticeList, data)

      if (res.code == 0) {
  
        this.list =  res.data.content;
        
      } else {
        this.$message.error(res.msg)
      }
    },
  },
  computed:{
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: this.list.length,
      };
    },
  }
};
</script>

<style lang="scss" scoped>
  #notice{
    display: flex;
    // justify-content: center;
    align-items: center;
    .domain {
      flex: 1;
      height: 45px;
      width: auto;
    }
  }
  .bn-title {
    float: left;
    width: 100px;
    min-width: 100px;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    text-indent: 34px;
    color: #fff;
    background: url('../assets/images/amjs/news.png') no-repeat 0;
    cursor: pointer;
  }

  .seamless-warp2 {
    overflow: hidden;
    height: 36px;
    background: rgba(0,0,0,.3);
    width: 1100px;
    cursor:pointer;
    ul.item {
      width: max-content;
      li {
        width: max-content;
        height: 36px;
        line-height: 36px;
        float: left;
        margin-right: 10px;
        color: #fff
      }
    }
  }
</style>
